export const OHL = {
    name: 'DV 1168 RP ĐERDAP 2 - TS PRAHOVO',
    voltage: '110',
    regionCode: 'BR',
    stanice: [{name: 'ĐERDAP 2', position: {lat: 44.2983, lng: 22.565}}],
    stubovi: [
        { index: 1, name: 'P-12', lat: 44.2977 , lng: 22.5655, sys: 1, portal: true},
        { index: 2, name: '1', lat: 44.2972 , lng: 22.5655, sys: 1},
        { index: 3, name: '2', lat: 44.2964 , lng: 22.5661, sys: 1},
        { index: 4, name: '3', lat: 44.2949 , lng: 22.5672, sys: 1},
        { index: 5, name: '4', lat: 44.2938 , lng: 22.568, sys: 1},
        { index: 6, name: '5', lat: 44.2924 , lng: 22.5704, sys: 1},
        { index: 7, name: '6', lat: 44.291 , lng: 22.5728, sys: 1},
        { index: 8, name: '7', lat: 44.2896 , lng: 22.5752, sys: 1},
        { index: 9, name: '8', lat: 44.2882 , lng: 22.5778, sys: 1},
        { index: 10, name: '9', lat: 44.2871 , lng: 22.5797, sys: 1},
        { index: 11, name: '10', lat: 44.2858 , lng: 22.5819, sys: 1},
        { index: 12, name: '11', lat: 44.2843 , lng: 22.5844, sys: 1},
        { index: 13, name: '12', lat: 44.2838 , lng: 22.5856, sys: 1},
        { index: 14, name: '13', lat: 44.2832 , lng: 22.5872, sys: 1},
        { index: 15, name: '14', lat: 44.2835 , lng: 22.5905, sys: 1},
        { index: 16, name: '15', lat: 44.2837 , lng: 22.5936, sys: 1},
        { index: 17, name: '16', lat: 44.284 , lng: 22.5966, sys: 1},
        { index: 18, name: '17', lat: 44.2843 , lng: 22.5994, sys: 1},
        { index: 19, name: '18', lat: 44.2845 , lng: 22.6017, sys: 1},
        { index: 20, name: 'P-03', lat: 44.2848 , lng: 22.6023, sys: 1, portal: true}
    ],
    rasponi: [
        { name: 'P-12 - 1', position: [{ lat: 44.2977 , lng: 22.5655 }, { lat: 44.2972 , lng: 22.5655 }] },
        { name: '1 - 2', position: [{ lat: 44.2972 , lng: 22.5655 }, { lat: 44.2964 , lng: 22.5661 }] },
        { name: '2 - 3', position: [{ lat: 44.2964 , lng: 22.5661 }, { lat: 44.2949 , lng: 22.5672 }] },
        { name: '3 - 4', position: [{ lat: 44.2949 , lng: 22.5672 }, { lat: 44.2938 , lng: 22.568 }] },
        { name: '4 - 5', position: [{ lat: 44.2938 , lng: 22.568 }, { lat: 44.2924 , lng: 22.5704 }] },
        { name: '5 - 6', position: [{ lat: 44.2924 , lng: 22.5704 }, { lat: 44.291 , lng: 22.5728 }] },
        { name: '6 - 7', position: [{ lat: 44.291 , lng: 22.5728 }, { lat: 44.2896 , lng: 22.5752 }] },
        { name: '7 - 8', position: [{ lat: 44.2896 , lng: 22.5752 }, { lat: 44.2882 , lng: 22.5778 }] },
        { name: '8 - 9', position: [{ lat: 44.2882 , lng: 22.5778 }, { lat: 44.2871 , lng: 22.5797 }] },
        { name: '9 - 10', position: [{ lat: 44.2871 , lng: 22.5797 }, { lat: 44.2858 , lng: 22.5819 }] },
        { name: '10 - 11', position: [{ lat: 44.2858 , lng: 22.5819 }, { lat: 44.2843 , lng: 22.5844 }] },
        { name: '11 - 12', position: [{ lat: 44.2843 , lng: 22.5844 }, { lat: 44.2838 , lng: 22.5856 }] },
        { name: '12 - 13', position: [{ lat: 44.2838 , lng: 22.5856 }, { lat: 44.2832 , lng: 22.5872 }] },
        { name: '13 - 14', position: [{ lat: 44.2832 , lng: 22.5872 }, { lat: 44.2835 , lng: 22.5905 }] },
        { name: '14 - 15', position: [{ lat: 44.2835 , lng: 22.5905 }, { lat: 44.2837 , lng: 22.5936 }] },
        { name: '15 - 16', position: [{ lat: 44.2837 , lng: 22.5936 }, { lat: 44.284 , lng: 22.5966 }] },
        { name: '16 - 17', position: [{ lat: 44.284 , lng: 22.5966 }, { lat: 44.2843 , lng: 22.5994 }] },
        { name: '17 - 18', position: [{ lat: 44.2843 , lng: 22.5994 }, { lat: 44.2845 , lng: 22.6017 }] },
        { name: '18 - P-03', position: [{ lat: 44.2845 , lng: 22.6017 }, { lat: 44.2848 , lng: 22.6023 }] }
    ]
}

